import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import {
  FAVORITE_SEARCH_SLOTS,
  fipsMap,
  countyMap,
  SearchModes,
  SearchLayouts,
  SearchOverlays,
  clearSuggestion,
  loadSearch,
  setSuggestionValue,
  setSuggestionLabel,
  searchSuggestions,
  setRecentSuggestions,
  selectSuggestion,
  setSuggestions,
  clearFilter,
  clearAll,
  clearLocalFilter,
  selectFavoriteSearches,
  selectFavoriteSearchCounts,
  selectFavoriteSearchLoading,
  selectFavoriteSearchStale,
  clearLeadListApiData,
  setSelectedSaveSearch,
  setFavoriteItem,
  selectFavoriteSelectedName
} from 'data/search';

import Button from 'components/base/Button';
import HeaderSearchItem from 'components/HeaderSearchItem';
import SuggestedInput from 'components/SuggestedInput';

import RestrictedContent from 'app/components/RestrictedContent';
import { Permissions } from 'data/user/constants';

import AllSearches from './AllSearches';
import SavedSearch from './SavedSearch';
import SearchFilter from './SearchFilter';
import css from './style.scss';
import SearchIcon from '../../../assets/images/search-icon.svg';
import SearchFilterNew from './searchFilterNew/SearchFilterNew';
import { TagFilterProvider } from './searchFilterNew/TagFilterContext';
import NewUIFilterSaved from './searchFilterNew/UIFilterSave'

const RECENT_SUGGESTION_PATH = 'PropStream.RecentSuggestions.1';
const MAX_RECENT_SUGGESTIONS = 15;

const FavoriteSlots = Array.from({ length: FAVORITE_SEARCH_SLOTS }, (v, i) => i + 1);

const Layouts = [
  { code: SearchLayouts.Picture, icon: 'iconPicture', className: css.iconPic, label: 'Pic View' },
  { code: SearchLayouts.Grid, icon: 'iconList', className: css.iconList, label: 'List View' },
];


const getRecentSuggestions = () => {
  try {
    return JSON.parse(window.localStorage.getItem(RECENT_SUGGESTION_PATH)).filter(i => !!i && !!i.label);
  } catch (e) {
    return [];
  }
};

const setRecentSuggestion = (item) => {
  let items = [];

  try {
    items = getRecentSuggestions();

    const key = (item.label || '').trim().toLowerCase();

    if (key !== '') {
      items = items.filter(s => s.key !== key);
      items.unshift({ ...item, key });
      items.length = Math.min(items.length, MAX_RECENT_SUGGESTIONS);

      window.localStorage.setItem(RECENT_SUGGESTION_PATH, JSON.stringify(items));
    }
    // eslint-disable-next-line no-empty
  } catch (e) {
    throw e;
  }

  return items;
};

// TODO: This should not exist, and APN suggestions should come from the server. County ID should be used instead of FIPS.
const parseSuggestion = (query) => {
  let localResults = [];

  /**
   * Check for county matches. Allow:
   * Orange County, CA (County Only)
   * #93974065, Orange County, CA (APN + County)
   * 06059; (FIPS Only)
   * 06059;93974065
   *
   * Use local results only if this is a FIPS and/or APN search
   */
  if (query !== '') {
    // Check for FIPS pattern
    let countyQuery = query;
    let match = /^(\d{5})#([a-z0-9\s-\s.]+)?$/i.exec(query);

    if (match && match[1]) {
      // Convert to "<apn>, <county>, <state> format
      const apn = match[2] && match[2].trim();
      const county = fipsMap[match[1]];
      if (county) countyQuery = `${apn ? `#${apn}, ` : ''}${county.search}, ${county.state}`;
    }

    match = /^((((apn)?#)([a-z0-9\s-\s.]+)),)?([a-z\s'-]+)(,\s*([a-z]{2}))?$/i.exec(countyQuery) || [];
    const stateMatch = match[8];
    const countyMatch = match[6] || '';
    const apn = match[5] ? match[5].trim() : null;

    if (stateMatch && countyMatch.length > 3 && apn) {
      // const county = countyMap[`${match[3].trim().replace(/\s+county$/i, '')}-${match[5].trim()}`.toLowerCase()];
      const search = countyMatch.toLowerCase().replace(/[^a-z]+/g, ' ').replace(/\s+county$/, '').trim();
      const explicitCountySearch = countyMatch.toLowerCase().includes(' county');

      // Pull all matching counties for respective state. Ignore independent cities / non-counties unless "county" is in the search string OR APN is provided.
      // If neither of those is true then the independent city should already be in the Bing results.
      localResults = localResults.concat((countyMap[stateMatch.toUpperCase()] || []).filter(c => c.search.includes(search) && (c.county || explicitCountySearch || apn)).map((county) => {
        const label = `${apn ? `APN# ${apn}, ` : ''}${county.name}`;
        // return { name, address: { fips: county.fips, apn, formattedAddress: name }, score: (apn ? 5 : 0) + (explicitCountySearch ? 3 : 1) };
        return { label, fips: county.fips, apn };
      }));
    }
  }

  return localResults;
};


class Header extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchItem: '',
    };
    this.handleClear = this.handleClear.bind(this);
    this.handleClearSuggestion = this.handleClearSuggestion.bind(this);
    this.handleChangeSuggestion = this.handleChangeSuggestion.bind(this);
    this.handleFetchSuggestion = this.handleFetchSuggestion.bind(this);
    this.handleFavoriteClick = this.handleFavoriteClick.bind(this);

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.setRecentSuggestions(getRecentSuggestions(), true);
  }

  componentWillUnmount() {
    this.setState({ searchItem: '' });
    this.props.setFavoriteItem('')
    this.handleClearSuggestion();
  }

  handleClear() { 
    this.setState({ searchItem: '' });
    this.props.setFavoriteItem('')
    this.props.clearAll();
    this.props.setSelectedSaveSearch(null);
    this.props.clearLeadListApiData();
    this.props.clearFilter();
    this.props.clearLocalFilter();
  }

  handleClearSuggestion() {
    this.props.clearSuggestion();
    this.setState({ searchItem: '' });
  }

  handleChangeSuggestion(item) {
    const { setSuggestionValue, setRecentSuggestions } = this.props;
    this.setState({ searchItem: item });

    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();

    const loc = item;
    if (loc) {
      const { type, cityId, id } = loc;

      if (type === 'P') loc.propertyId = id;
      else if (!cityId && type === 'C') loc.cityId = id;

      setRecentSuggestions(setRecentSuggestion(loc));
    }

    setSuggestionValue(loc);
  }

  handleFetchSuggestion(query) {
    const { setSuggestionLabel, searchSuggestions, setSuggestions } = this.props;

    setSuggestionLabel(query);

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }

    if (query && query.length >= 5) {
      this.searchTimer = setTimeout(() => {
        this.searchTimer = null;

        // const orangeResults = [{"id":21432,"fips":"059","cityName":"Orange","stateCode":"CA","countyId":256,"latitude":33.78779,"longitude":-117.85311,"coded":false,"type":"C","title":"Orange, CA","label":"Orange, CA"},{"id":31119,"fips":"019","cityName":"Orange Park","stateCode":"FL","countyId":367,"latitude":30.16607,"longitude":-81.70648,"coded":false,"type":"C","title":"Orange Park, FL","label":"Orange Park, FL"},{"id":167551,"fips":"361","cityName":"Orange","stateCode":"TX","countyId":2541,"latitude":30.09299,"longitude":-93.73655,"coded":false,"type":"C","title":"Orange, TX","label":"Orange, TX"},{"id":150989,"fips":"075","cityName":"Orangeburg","stateCode":"SC","countyId":2211,"latitude":33.49182,"longitude":-80.85565,"coded":false,"type":"C","title":"Orangeburg, SC","label":"Orangeburg, SC"},{"id":3377,"fips":"003","cityName":"Orange Beach","stateCode":"AL","countyId":74,"latitude":30.29437,"longitude":-87.57359,"coded":false,"type":"C","title":"Orange Beach, AL","label":"Orange Beach, AL"},{"id":256,"fips":"059","cityName":"Orange County","stateCode":"CA","countyId":256,"latitude":33.74279,"longitude":-117.90784,"coded":false,"type":"N","title":"Orange County, CA","label":"Orange County, CA"},{"id":405,"fips":"095","cityName":"Orange County","stateCode":"FL","countyId":405,"latitude":28.5563,"longitude":-81.4096,"coded":false,"type":"N","title":"Orange County, FL","label":"Orange County, FL"},{"id":1758,"fips":"071","cityName":"Orange County","stateCode":"NY","countyId":1758,"latitude":41.43065,"longitude":-74.25543,"coded":false,"type":"N","title":"Orange County, NY","label":"Orange County, NY"},{"id":2211,"fips":"075","cityName":"Orangeburg County","stateCode":"SC","countyId":2211,"latitude":33.49849,"longitude":-80.85565,"coded":false,"type":"N","title":"Orangeburg County, SC","label":"Orangeburg County, SC"},{"id":2541,"fips":"361","cityName":"Orange County","stateCode":"TX","countyId":2541,"latitude":30.1316,"longitude":-93.83878,"coded":false,"type":"N","title":"Orange County, TX","label":"Orange County, TX"},{"id":1851,"fips":"135","cityName":"Orange County","stateCode":"NC","countyId":1851,"latitude":36.00264,"longitude":-79.06918,"coded":false,"type":"N","title":"Orange County, NC","label":"Orange County, NC"},{"id":2715,"fips":"137","cityName":"Orange County","stateCode":"VA","countyId":2715,"latitude":38.24305,"longitude":-78.010415,"coded":false,"type":"N","title":"Orange County, VA","label":"Orange County, VA"},{"id":745,"fips":"117","cityName":"Orange County","stateCode":"IN","countyId":745,"latitude":38.55839,"longitude":-86.46832,"coded":false,"type":"N","title":"Orange County, IN","label":"Orange County, IN"},{"id":2647,"fips":"017","cityName":"Orange County","stateCode":"VT","countyId":2647,"latitude":43.98757,"longitude":-72.3226,"coded":false,"type":"N","title":"Orange County, VT","label":"Orange County, VT"},{"id":22110,"fips":"067","cityName":"Orangevale","stateCode":"CA","countyId":260,"latitude":38.67851,"longitude":-121.22578,"coded":false,"type":"C","title":"Orangevale, CA","label":"Orangevale, CA"},{"id":38813,"fips":"127","cityName":"Orange City","stateCode":"FL","countyId":421,"latitude":28.94888,"longitude":-81.29867,"coded":false,"type":"C","title":"Orange City, FL","label":"Orange City, FL"},{"id":180924,"fips":"137","cityName":"Orange","stateCode":"VA","countyId":2715,"latitude":38.24541,"longitude":-78.11083,"coded":false,"type":"C","title":"Orange, VA","label":"Orange, VA"},{"id":27939,"fips":"009","cityName":"Orange","stateCode":"CT","countyId":351,"latitude":41.27843,"longitude":-73.02566,"coded":false,"type":"C","title":"Orange, CT","label":"Orange, CT"},{"id":105522,"fips":"013","cityName":"Orange","stateCode":"NJ","countyId":1677,"latitude":40.77066,"longitude":-74.23265,"coded":false,"type":"C","title":"Orange, NJ","label":"Orange, NJ"},{"id":166079,"fips":"249","cityName":"Orange Grove","stateCode":"TX","countyId":2489,"latitude":27.95668,"longitude":-97.93694,"coded":false,"type":"C","title":"Orange Grove, TX","label":"Orange Grove, TX"},{"id":59587,"fips":"167","cityName":"Orange City","stateCode":"IA","countyId":837,"latitude":43.00721,"longitude":-96.05835,"coded":false,"type":"C","title":"Orange City, IA","label":"Orange City, IA"},{"id":83144,"fips":"011","cityName":"Orange","stateCode":"MA","countyId":1162,"latitude":42.59036,"longitude":-72.30981,"coded":false,"type":"C","title":"Orange, MA","label":"Orange, MA"},{"id":18806,"fips":"019","cityName":"Orange Cove","stateCode":"CA","countyId":237,"latitude":36.62439,"longitude":-119.31373,"coded":false,"type":"C","title":"Orange Cove, CA","label":"Orange Cove, CA"},{"id":114132,"fips":"087","cityName":"Orangeburg","stateCode":"NY","countyId":1766,"latitude":41.04649,"longitude":-73.94958,"coded":false,"type":"C","title":"Orangeburg, NY","label":"Orangeburg, NY"},{"id":139313,"fips":"037","cityName":"Orangeville","stateCode":"PA","countyId":2130,"latitude":41.07814,"longitude":-76.41439,"coded":false,"type":"C","title":"Orangeville, PA","label":"Orangeville, PA"},{"id":170764,"fips":"015","cityName":"Orangeville","stateCode":"UT","countyId":2621,"latitude":39.22719,"longitude":-111.0535,"coded":false,"type":"C","title":"Orangeville, UT","label":"Orangeville, UT"},{"id":52827,"fips":"177","cityName":"Orangeville","stateCode":"IL","countyId":673,"latitude":42.46835,"longitude":-89.64401,"coded":false,"type":"C","title":"Orangeville, IL","label":"Orangeville, IL"},{"id":104075,"fips":"009","cityName":"Orange","stateCode":"NH","countyId":1665,"latitude":43.65452,"longitude":-71.97147,"coded":false,"type":"C","title":"Orange, NH","label":"Orange, NH"},{"id":174565,"fips":"017","cityName":"Orange","stateCode":"VT","countyId":2647,"latitude":44.1484,"longitude":-72.4026,"coded":false,"type":"C","title":"Orange, VT","label":"Orange, VT"},{"id":126199,"fips":"035","cityName":"Orange","stateCode":"OH","countyId":1944,"latitude":41.44978,"longitude":-81.48067,"coded":false,"type":"C","title":"Orange, OH","label":"Orange, OH"},{"id":131273,"fips":"155","cityName":"Orangeville","stateCode":"OH","countyId":1996,"latitude":41.33922,"longitude":-80.51896,"coded":false,"type":"C","title":"Orangeville, OH","label":"Orangeville, OH"},{"id":167552,"fips":"361","cityName":"Orangefield","stateCode":"TX","countyId":2541,"latitude":30.07493,"longitude":-93.85573,"coded":false,"type":"C","title":"Orangefield, TX","label":"Orangefield, TX"},{"id":126015,"fips":"031","cityName":"Orange","stateCode":"OH","countyId":1943,"latitude":40.28813,"longitude":-81.6829,"coded":false,"type":"C","title":"Orange, OH","label":"Orange, OH"}];
        // this.props.setSuggestions(orangeResults);

        const results = parseSuggestion(query);

        if (results.length) setSuggestions(results);
        else searchSuggestions(query);
      }, 800);
    }

    return Promise.resolve([]);
  }

  handleFavoriteClick(search) {
    const tab = search.toJS();
    this.props.setFavoriteItem(tab);

    const favoriteCounts = this.props.favoriteCounts || new Map();
    console.log(favoriteCounts, tab, "props");

    const count = favoriteCounts.get(String(tab.id), 0);
    tab.totalCount = count;

    if (this.props.suggestionValue || tab.totalCount != null) {
        this.props.loadSearch(tab);
    }
}

  render() {
    const {
      location,
      result,
      onLayoutChange,
      onSearch,
      clearAll,
      favoriteSearches,
      favoriteCounts,
      favoriteLoading,
      favoriteStale,
      recentLoaded,
      loading,
      activeFavouriteId,
      label,
      items,
      query,
      suggestionLoading,
      favoriteSelectedName
    } = this.props;

    const mode = result.get('mode');

    let layout;
    const listingMode = mode === SearchModes.Listing || mode === SearchModes.Multiple;
    if (listingMode) layout = result.get('overlay') === SearchOverlays.Property ? SearchLayouts.Grid : result.get('layout');

    return (
      <header className={css.appHeader}>
        <div className={css.top}>
          <div className={css.row}>
            <div className={css.col}>
              <div className={css.searchInput}>
                <div className={css.search}>
                  <SuggestedInput
                    // searchValue={searchValue}
                    isRecent={recentLoaded}
                    value={label}
                    suggestions={items}
                    loading={suggestionLoading}
                    onChange={this.handleChangeSuggestion}
                    onFetch={this.handleFetchSuggestion}
                    // onFocus={loadRecentSuggestions}
                    clearSearch={this.handleClearSuggestion}
                    placeholder="Enter County, City, Zip Code(s) or APN #"
                  />
                </div>
                <div className={`${css.iconSearch} ${items?.length && label?.length >= 5 && !loading ? '' : css.disabled}`}  onClick={() => this.handleChangeSuggestion(items[0])}>
                  <img src={SearchIcon} alt="Search" />
                  <span className={css.searchText}>Search</span>
                </div>
              </div>
            </div>
            <div className={css.col}>
              <TagFilterProvider>
                <SearchFilterNew />
              </TagFilterProvider>
            </div> 
            <div className={css.col}>
              <NewUIFilterSaved />
            </div>
            <div className={css.col}>
              <Button kind="link-default" className={css.clearAllBtn} size="large" onClick={this.handleClear}>Clear All</Button>
            </div>
          </div>
        </div>
        <div className={css.bottom}>
          <div className={css.clsCardSection}>
            <div className={css.row}>
              {FavoriteSlots.map((idx) => {
                const search = favoriteSearches.get(String(idx), Map());
                const id = search.get('id');

                return (
                  <div key={idx} className={css.col}>
                    {!(favoriteLoading || favoriteStale) ? null : <HeaderSearchItem label="Loading" />}
                    {favoriteLoading || favoriteStale || !search.get('name') ? null : (
                      <RestrictedContent permission={!search.get('id') || search.get('enabled')}>
                        <HeaderSearchItem
                          newFeature={false}
                          label={search.get('name')}
                          value={!id ? null : favoriteCounts.get(String(id), 0)}
                          onClick={!id ? null : () => this.handleFavoriteClick(search)}
                          isActive={favoriteSelectedName && 
                            (favoriteSelectedName?.value === search.get('listingType') && 
                            favoriteSelectedName?.label === search.get('name')) ||
                            (favoriteSelectedName?.listingType === search.get('listingType') && 
                            favoriteSelectedName?.name === search.get('name'))
                          }
                        />
                      </RestrictedContent>
                    )}
                  </div>
                );
              })}
              <div className={css.col}>
                <RestrictedContent permission={Permissions.searchFull}>
                  <AllSearches query={query} handleClear={this.handleClear} />
                </RestrictedContent>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default connect((state) => {
  const suggestion = selectSuggestion(state).toJS();

  return {
    ...suggestion,
    suggestionLoading: suggestion.loading,
    suggestionValue: suggestion.value,
    favoriteSearches: selectFavoriteSearches(state),
    favoriteCounts: selectFavoriteSearchCounts(state),
    favoriteLoading: selectFavoriteSearchLoading(state),
    favoriteStale: selectFavoriteSearchStale(state),
    favoriteSelectedName: selectFavoriteSelectedName(state)
  };
}, {
  clearSuggestion,
  loadSearch,
  setSuggestionValue,
  setSuggestionLabel,
  searchSuggestions,
  setRecentSuggestions,
  setSuggestions,
  clearFilter,
  clearLocalFilter,
  clearAll,
  clearLeadListApiData,
  setSelectedSaveSearch,
  setFavoriteItem
})(Header);
